import { FormField } from '@domgen/dgx-fe-forms/layout';
import { CmsModelAndSerialNumberFieldset } from './cms-model-and-serial-number-fieldset.interface';
import { CmsPersonalDetailsFieldset } from './cms-personal-details-form-fieldset.interface';

export interface RegistrationCodeFormField extends FormField {
  fieldHintBefore?: string;
  fieldHintLinkText?: string;
  fieldHintAfter?: string;
}

export interface CmsApplianceDetailsSteppedForm {
  applianceCategoryCodeField: FormField;
  applianceCodeField: FormField;
  brandCodeField: FormField;
  modelAndSerialNumberFieldset: CmsModelAndSerialNumberFieldset;
  personalDetailsFieldSet: CmsPersonalDetailsFieldset;
  purchaseDateField: FormField;
  purchasePriceField: FormField;
  registrationCodeField: RegistrationCodeFormField;
}
